// extracted by mini-css-extract-plugin
module.exports = {"privateFiltersControls__container":"src-components-CustomTable-CustomTable-module__privateFiltersControls__container--f0IHe"};